import { on } from '@ember/modifier';
import { action, set } from '@ember/object';
import Component from '@glimmer/component';
import { and, or } from 'ember-truth-helpers';
import type { MappedFieldInviteArg } from 'invite-sign/components/mapped-field';
import type Entry from 'invite-sign/models/entry';
import type SignInField from 'invite-sign/models/sign-in-field';

interface EmailFieldSignature {
  Args: {
    entry?: Entry;
    id: string;
    invite?: MappedFieldInviteArg;
    mappedField: SignInField;
  };
}

export default class EmailField extends Component<EmailFieldSignature> {
  @action
  onChange(e: Event) {
    const target = <HTMLInputElement>e.target;
    set(this.args.mappedField, 'value', target.value);
    if (this.args.entry) set(this.args.entry, 'email', target.value);
    this.args.mappedField.validate();
  }

  <template>
    <input
      data-test-field
      id={{@id}}
      type="email"
      name={{@mappedField.identifier}}
      class="inputClass rounded-md"
      value={{@mappedField.value}}
      disabled={{or (and @invite.employeeScreeningFlow @mappedField.isName) @mappedField.isDisabled}}
      {{on "change" this.onChange}}
    />
  </template>
}
